import { TickCircle } from "iconsax-react";
import { useParams } from "react-router-dom";

export default function PaymentSuccess() {
  const { data } = useParams();

  return (
    <div className="flex items-center justify-center min-h-screen bg-emerald-50 p-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8 text-center">
        <div className="flex justify-center mb-6">
          <TickCircle
            size="80"
            color="#10b981"
            variant="Bold"
            className="animate-bounce"
          />
        </div>

        <h1 className="text-3xl font-bold text-emerald-700 mb-6 font-vazirmatn">
          با موفقیت پرداخت شد
        </h1>

        <p className="text-gray-700 text-lg mb-4 leading-relaxed font-vazirmatn">
          خوش اومدی به جمعمون! به‌زودی همه‌ی جزئیات دوره برات ارسال می‌شه (از
          طریق واتساپ یا پیامک) منتظریم با هم یه مسیر قشنگ بسازیم
        </p>
        <div className="h-[1px] w-auto bg-emerald-600 mb-4"></div>
        <span className="text-base text-emerald-800">
          از این صفحه اسکرین شات بگیر و برای پشتیبانی ارسال کن
        </span>
        <div className="mt-8 flex flex-col items-center">
          <div
            className="px-6 py-3 w-full rounded-xl "
            style={{ border: "2px dashed #10b981" }}
          >
            <span>{data}</span>
          </div>
          <a
            href="/landing"
            className="px-6 py-3 mt-4 w-full bg-emerald-600 text-white rounded-lg font-medium hover:bg-emerald-700 transition-colors duration-300 font-vazirmatn"
          >
            بازگشت به صفحه اصلی
          </a>
        </div>
      </div>
    </div>
  );
}
